module.exports = __webpack_public_path__ + "img/logo.big.42c2b317.png";